import { mallDomainApi } from '../request'
import { apiPath } from '../api'

export const inspectReport = {
  getSkuCertInfo: data => mallDomainApi.post(apiPath.getSkuCertInfo, data)
}
